import { render } from "./App.vue?vue&type=template&id=024e922e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=024e922e&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__